import React, { useState, useEffect } from "react";
import { addDoc, collection, getDocs, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import TutorLayout from "./TutorLayout";

const subjects = {
  "GCSE Maths": ["Algebra", "Number", "Geometry"],
  "A-Level Maths": ["Pure", "Mechanics", "Statistics"],
  "GCSE French": ["Vocabulary", "Grammar", "Culture"],
  "A-Level French": ["Topics", "Grammar", "Literature"],
};

function UploadLessonResource() {
  const [subject, setSubject] = useState("GCSE Maths");
  const [topic, setTopic] = useState("");
  const [subtopic, setSubtopic] = useState("");
  const [title, setTitle] = useState("");
  const [slidesUrl, setSlidesUrl] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [assignedToUID, setAssignedToUID] = useState("");
  const [students, setStudents] = useState([]);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    const fetchStudents = async () => {
      const snapshot = await getDocs(collection(db, "users"));
      const studentList = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(user => user.role === "student");
      setStudents(studentList);
    };

    fetchStudents();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title || !topic || !subtopic || !assignedToUID) {
      alert("Please fill in all required fields.");
      return;
    }

    setUploading(true);
    try {
      await addDoc(collection(db, "lessonResources"), {
        title,
        subject,
        topic,
        subtopic,
        slidesUrl,
        videoUrl,
        uploadedAt: serverTimestamp(),
        assignedToUID,
      });
      alert("✅ Resource uploaded successfully!");
      setTitle("");
      setSlidesUrl("");
      setVideoUrl("");
      setTopic("");
      setSubtopic("");
      setAssignedToUID("");
    } catch (err) {
      console.error("Error uploading resource:", err);
      alert("❌ Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <TutorLayout>
      <div style={styles.container}>
        <h1>📤 Upload Lesson Resource</h1>
        <form onSubmit={handleSubmit} style={styles.form}>
          <label>Student</label>
          <select
            value={assignedToUID}
            onChange={(e) => setAssignedToUID(e.target.value)}
            style={styles.input}
          >
            <option value="">-- Select Student --</option>
            {students.map((s) => (
              <option key={s.id} value={s.uid}>
                {s.displayName || s.email}
              </option>
            ))}
          </select>

          <label>Subject</label>
          <select value={subject} onChange={(e) => setSubject(e.target.value)} style={styles.input}>
            {Object.keys(subjects).map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>

          <label>Topic</label>
          <select value={topic} onChange={(e) => setTopic(e.target.value)} style={styles.input}>
            <option value="">-- Select Topic --</option>
            {(subjects[subject] || []).map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>

          <label>Subtopic</label>
          <input
            type="text"
            value={subtopic}
            onChange={(e) => setSubtopic(e.target.value)}
            placeholder="e.g. Expanding Brackets"
            style={styles.input}
          />

          <label>Lesson Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="e.g. Lesson 3 – Expanding Brackets"
            style={styles.input}
          />

          <label>Google Slides URL (optional)</label>
          <input
            type="url"
            value={slidesUrl}
            onChange={(e) => setSlidesUrl(e.target.value)}
            placeholder="https://docs.google.com/presentation/..."
            style={styles.input}
          />

          <label>Video URL (optional)</label>
          <input
            type="url"
            value={videoUrl}
            onChange={(e) => setVideoUrl(e.target.value)}
            placeholder="https://youtube.com/..."
            style={styles.input}
          />

          <button type="submit" disabled={uploading} style={styles.button}>
            {uploading ? "Uploading..." : "Upload Resource"}
          </button>
        </form>
      </div>
    </TutorLayout>
  );
}

const styles = {
  container: {
    padding: "2rem",
    fontFamily: "'Fredoka', cursive",
    backgroundColor: "#f0f8ff",
    minHeight: "100vh",
  },
  form: {
    maxWidth: "600px",
    marginTop: "1.5rem",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  input: {
    padding: "0.6rem",
    fontSize: "1rem",
    borderRadius: "6px",
    border: "1px solid #ccc",
  },
  button: {
    padding: "0.75rem",
    backgroundColor: "#0984e3",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "bold",
  },
};

export default UploadLessonResource;
